import React from 'react'

const styles = {
  container: {
    flex: '1',
    minWidth: '250px',
  },
  section: {
    marginBottom: '16px',
  },
  entry: {
    fontFamily: 'var(--font-mono)',
    fontSize: '0.85rem',
    marginBottom: '4px',
  },
}

export default function EntryList({ acrossEntries, downEntries }) {
  const total = acrossEntries.length + downEntries.length

  return (
    <div style={styles.container}>
      <h3 style={{ marginTop: 0 }}>Entries ({total})</h3>

      <div style={styles.section}>
        <h4>Across ({acrossEntries.length})</h4>
        {acrossEntries.map(e => (
          <div key={e.num} style={styles.entry}>
            <strong>{e.num}.</strong> {e.word} ({e.length})
          </div>
        ))}
      </div>

      <div style={styles.section}>
        <h4>Down ({downEntries.length})</h4>
        {downEntries.map(e => (
          <div key={e.num} style={styles.entry}>
            <strong>{e.num}.</strong> {e.word} ({e.length})
          </div>
        ))}
      </div>
    </div>
  )
}
